export const SETTINGS_PATH = "/settings";
export const SETTINGS_GENERAL_PATH = "/settings/general";
export const SETTINGS_WORKSTATION_PATH = "/settings/workstation";
export const SETTINGS_BINS_PATH = "/settings/bins";
export const SETTINGS_BATCHES_PATH = "/settings/batches";
export const SETTINGS_GRID_PATH = "/settings/grid";
export const SETTINGS_API_TOKENS_PATH = "/settings/api-tokens";

export const SETTINGS_PREVIEW_GENERAL_PATH = "/settings/preview/general";
export const SETTINGS_PREVIEW_WORKSTATION_PATH =
  "/settings/preview/workstation";
export const SETTINGS_PREVIEW_BINS_PATH = "/settings/preview/bins";
export const SETTINGS_PREVIEW_BATCHES_PATH = "/settings/preview/batches";
export const SETTINGS_PREVIEW_UPDATE_CONFIGURATION_PATH =
  "/settings/preview/update-configuration";

export const DEV_TOOLS_LOG_PUBLISHER_GRID_PATH =
  "/dev-tools/log-publisher-grid";
export const DEV_TOOLS_SERVICE_SUPPORT_EVENTS_PREVIEW_PATH =
  "/dev-tools/service-support-events-preview";
export const DEV_TOOLS_ICON_LIST_PATH = "/dev-tools/icon-list";

export const DESIGN_PREVIEW_MODAL_NAV_OPTIONS = [
  {
    path: SETTINGS_PREVIEW_GENERAL_PATH,
    labelKey: "nav.viewname.settings general"
  },
  {
    path: SETTINGS_PREVIEW_WORKSTATION_PATH,
    labelKey: "nav.viewname.settings workstation preview"
  },
  {
    path: SETTINGS_PREVIEW_BINS_PATH,
    labelKey: "nav.viewname.settings bins"
  },
  {
    path: SETTINGS_PREVIEW_BATCHES_PATH,
    labelKey: "nav.viewname.settings batches"
  },
  {
    path: DEV_TOOLS_LOG_PUBLISHER_GRID_PATH,
    labelKey: "nav.viewname.settings grid view"
  },
  {
    path: DEV_TOOLS_SERVICE_SUPPORT_EVENTS_PREVIEW_PATH,
    labelKey: "nav.viewname.service support events"
  }
] as const;
